import { REGEXPS } from '@/common';

export const normalizePropertyName = (propertyName: string) =>
  propertyName.replace(REGEXPS.CUSTOM_REPORTING_FIELD_NAME, '$1custom_reporting_field_$2_$3');
